module.exports = __webpack_public_path__ + "img/SketchPng9efb9f4b61e066c14e274070af8cd363b1a186b18ca2ffe73c893330a9c80336.904e42c6.png";